import request from '@/utils/request'
import { orderPrefix, packagePrefix, userPrefix } from './config'

// 创建订单
export const createOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/user-order/create`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取订单列表
export const getOrderList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/userOrderList`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取提包订单列表
export const getSubmitOrderList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/userOrderList`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取商品详情步骤
export const getProductStepList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/itemStepList`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 修改订单备注接口
export const editOrderItemRemark = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/edit/itemComment`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消已支付订单
export const cancelPaidOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/cancelOrder`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消已支付商品（AI维度）
export const canceUnPaidOrderItems = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/cancelOrderItems`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消待支付订单
export const cancelUnpaidOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/orderWaitPayCancel`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 删除订单
export const delOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/deleteOrder`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消订单
export const cancelOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/cancelOrder`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取等待处理订单
export const getWaitingOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/userPendingList`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 添加定制图片订单
export const addFinePictures = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/addFinePictures`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 修改定制图片备注
export const editPicturesComment = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/edit/pictureComment`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消定制图片服务
export const cancelPicturesServe = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/cancelAppendService`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 计算延长保管费用
export const calcExternalCareFee = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${packagePrefix}/platform/fee/calPlatformFees`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 生成增加保管时间订单
export const createAddProductCareTime = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/addStorageTime`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 更改商品包装方式
export const changeProductPackMode = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/changeItemPackService`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 更改商品标签
export const changeProductTag = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/changeItemPackService`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 退货
export const applyExchangeItem = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/applyExchangeItem`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 换货
export const applyReturnItem = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/applyReturnItem`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取用户剩余优惠次数
export const discountNums = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${userPrefix}/consumeRecord/discount/nums`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 我知道了
export const confirmOrder = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/item/confirm`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消退货
export const returnBagCancel = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/returnItemCancel`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消换货
export const exchangeBagCancel = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/exchangeItemCancel`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 取消补款
export function cancelRepairPay(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/cancelFil`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 去支付商品补款
export function repairPayProduct(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/itemFil`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 去支付运费补款
export function repairPayPostage(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/postageFil`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 去支付运费和商品补款
export function mergeRepairPay(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/postageAndItemFil`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 继续支付 附加服务
export function continuePay(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/continuePay`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取订单状态
export function getOrderItemStatus(params) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/getItemStatusCount`, params)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 已订购状态超7天（用户可以申请撤单（或叫申请退款）操作
export function refundApply(data) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/apply/refundApply`, data)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 需要客户待确认回复
export function replyProductInfo(data) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/confirmAlready`, data)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 需要客户确认信息
export function confirmProductInfo(data) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/item/confirm`, data)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 创建转移订单
export function createTransportOrder(data) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/api/add/userTransitOrder`, data)
    if (res.code === 200 || res.code === 0) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取服务图片分享
export const getOrderProductQcImagesShare = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${orderPrefix}/api/getOrderProductQcImages`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 添加qc视频
export const addOrderProductQcVideo = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/addVideoQc`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 批量取消增值服务`
export const batchCancelAppendService = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/batchCancelAppendService`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取订单数量
export const getOrderCount = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/getOrderCount`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 催促发货
export const remindShop = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${orderPrefix}/shipmentReminder`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
